import { t } from '@lingui/macro';

import { COLUMN_TYPES } from '../../data-table/DataTableColumns';
import { AdminPages, buildPageTarget } from '../AdminLinkUtils';
import { formatTags } from '../../../utilities/StringUtilities';
import { ROLE_NAMES } from '../users/UserConstants';

export const DEFAULT_GROUP_UUID = '00000000-0000-0000-0000-000000000000';

export const GROUPS_ADMIN_NAME_FIELD = 'groupName';
export const GROUPS_ADMIN_DESCRIPTION_FIELD = 'description';
export const GROUPS_ADMIN_ALLOW_DRILL_IN_FIELD = 'allowDrillIn';
export const GROUPS_ADMIN_LANDING_PAGE_FIELD = 'landingPage';
export const GROUPS_ADMIN_USERS_FIELD = 'users';
export const GROUPS_ADMIN_SITES_FIELD = 'sites';
export const GROUPS_ADMIN_BUSINESS_SERVICES_FIELD = 'businessServices';
export const GROUPS_ADMIN_PAGES_FIELD = 'pages';
export const GROUPS_ADMIN_DASHBOARDS_FIELD = 'userDashboards';

export const NO_LANDING_PAGE_DEFAULT = { key: 'System Default', value: 'system_default' };

export const GROUPS_ADMIN_LIST_COLUMNS = [
    {
        type: COLUMN_TYPES.LINK,
        mapping: GROUPS_ADMIN_NAME_FIELD,
        title: t`Group Name`,
        width: 240,
        sortable: true,
        link: {
            sysAdminOnly: true,
            target: buildPageTarget(AdminPages.Groups),
        },
    },
    {
        type: COLUMN_TYPES.TEXT,
        mapping: 'userCount',
        title: t`Members`,
        sortable: true,
        width: 120,
    },
    {
        type: COLUMN_TYPES.TEXT,
        mapping: GROUPS_ADMIN_ALLOW_DRILL_IN_FIELD,
        title: t`Can Drill In`,
        sortable: true,
        width: 160,
        formatter: (value) => (value ? t`Yes` : t`No`),
    },
    {
        type: COLUMN_TYPES.TEXT,
        mapping: GROUPS_ADMIN_DESCRIPTION_FIELD,
        title: t`Description`,
        sortable: true,
        width: 640,
        maxWidth: 800,
    },
];

export const GROUPS_ADMIN_SITES_COLUMNS = [
    {
        type: COLUMN_TYPES.TEXT,
        mapping: 'name',
        title: t`Name`,
        width: 160,
        sortable: true,
    },
    {
        type: COLUMN_TYPES.TEXT,
        mapping: 'description',
        title: t`Description`,
        width: 160,
        sortable: true,
    },
    {
        type: COLUMN_TYPES.TEXT,
        mapping: 'tags',
        title: t`Tags`,
        sortable: false,
        formatter: formatTags,
        width: 240,
    },
];

export const GROUPS_ADMIN_BUSINESS_SERVICES_COLUMNS = [
    {
        type: COLUMN_TYPES.TEXT,
        mapping: 'name',
        title: t`Name`,
        width: 160,
        sortable: true,
    },
    {
        type: COLUMN_TYPES.TEXT,
        mapping: 'description',
        title: t`Description`,
        width: 160,
        sortable: true,
    },
    {
        type: COLUMN_TYPES.TEXT,
        mapping: 'tags',
        title: t`Tags`,
        sortable: false,
        formatter: formatTags,
        width: 240,
    },
];

export const GROUPS_ADMIN_USERS_COLUMNS = [
    {
        type: COLUMN_TYPES.TEXT,
        mapping: 'userName',
        title: t`Username`,
        width: 200,
        sortable: true,
    },
    {
        type: COLUMN_TYPES.TEXT,
        mapping: 'firstName',
        title: t`First Name`,
        width: 200,
        sortable: true,
    },
    {
        type: COLUMN_TYPES.TEXT,
        mapping: 'lastName',
        title: t`Last Name`,
        width: 200,
        sortable: true,
    },
    {
        type: COLUMN_TYPES.TEXT,
        mapping: 'userRole',
        title: t`Role`,
        width: 200,
        sortable: true,
        formatter: (role) => ROLE_NAMES[role],
    },
    {
        type: COLUMN_TYPES.TEXT,
        mapping: 'email',
        title: t`Email`,
        width: 300,
        sortable: true,
    },
];

export const GROUPS_ADMIN_DASHBORDS_COLUMNS = [
    {
        type: COLUMN_TYPES.TEXT,
        mapping: 'title',
        title: t`Title`,
        width: 550,
        sortable: true,
    },
];

export function getGroupsAdminPagesColumns(classes) {
    return [
        {
            type: COLUMN_TYPES.ICON,
            title: '',
            sortable: false,
            width: 45,
            className: classes.pageIconColumnWrapper,
            icons: [
                {
                    getIcon: (row) => row.icon,
                },
            ],
        },
        {
            type: COLUMN_TYPES.TEXT,
            mapping: 'title',
            title: t`Page Title`,
            width: 500,
            sortable: true,
        },
    ];
}
